module.exports = __webpack_public_path__ + "img/hotspot-old.b179fdec.png";